import React from 'react'
import Map from '../../../../../../common/components/map'
import _ from 'lodash';
import { format } from '../../../../../../common/services/date.service';
import { Menu } from '@headlessui/react';
import MediaInfoComponent from '../../../../../../common/components/common/media-info.component';
import TripBasicInfoComponent from './trip-basic-info.component';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';

export default function TripComponent({ mediaFiles, handleFormMediaItemChange, fileTypes, changeImage, orderDetails, back, tripsDetails, getShippingType, ConvertMinutes }: any) {

    const tabItems = [
        {
            id: 1,
            title: 'Basic Info',
            component: <TripBasicInfoComponent
                orderDetails={orderDetails}
                tripsDetails={tripsDetails}
                getShippingType={getShippingType}
                ConvertMinutes={ConvertMinutes} />,
            isVisible: true,
        },
        {
            id: 2,
            title: 'E-Way Bill',
            component:
                <MediaInfoComponent
                    changeImage={changeImage}
                    // deleteSelectedProduct={deleteSelectedCategory}
                    fileTypes={fileTypes}
                    //handleClose={handleClose}
                    //handleOpen={handleOpen}
                    onFormItemChange={handleFormMediaItemChange}
                    // openConfirmation={openConfirmation}
                    mediaFiles={mediaFiles}
                //uploadToDigiiFolder={uploadToDigiiFolder}
                />,
            isVisible: true,
        },

    ]

    return (
        <div className="flex flex-col items-center w-full px-5 overflow-auto h-auto pb-20">


            <TabContainer tabItems={tabItems} />

            <div className='flex w-full justify-end items-end h-20'>
                <button
                    onClick={back}
                    type='button'
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                >
                    Back
                </button>

            </div>
        </div>
    )
}